import React, { PureComponent } from 'react'
import styled from 'styled-components/native'
import { View, Platform } from 'react-native'
import { Circle, Text, Rect, G } from 'react-native-svg'
import { LineChart as _LineChart, XAxis } from 'react-native-svg-charts'
import * as shape from 'd3-shape'

const Chart = styled(_LineChart)`
  flex: 1;
  width: 100%
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: ${props => props.zIndex};
`

const Container = styled(View)`
    flex: 1;
`

export default class LineChart extends PureComponent {
  render () {
    const {
      series,
      width,
      height,
      xAxis = null,
      yAxis = null,
      labelFormatter = (value) => value
    } = this.props

    const yAxisTickSpacing = (yAxis.yMax - yAxis.yMin) / yAxis.numberOfTicks

    const YAxis = ({ x, y, data }) => {
      const items = []
      for (let value = yAxis.yMin; value <= yAxis.yMax; value += yAxisTickSpacing) {
        items.push(
          <G
            key={value}
          >
            <Rect
              x={x(0)}
              y={y(value)}
              width={width - x(0)}
              height={1}
              fill={Object.prototype.hasOwnProperty.call(yAxis, 'baselineValue') && value === yAxis.baselineValue ? '#b1b1b1' : '#eeeeee'}
            />
            <Text
              x={x(0) - 10}
              y={y(value)}
              fontFamily={Platform.select({ web: 'ubuntu-bold' })}// TODO fontFamily fix
              fontSize={14}
              fontWeight='bold'
              alignmentBaseline='middle'
              textAnchor='end'
              fill='#888888'
            >
              {Object.prototype.hasOwnProperty.call(yAxis, 'labelFormatter') ? yAxis.labelFormatter(value) : value}
            </Text>
          </G>
        )
      }
      return items
    }

    return (
      <Container>
        {xAxis &&
          <XAxis {...xAxis} />}
        <Container style={{ height, width }}>
          {series.map((chart, i) => {
            const {
              data,
              stroke,
              strokeWidth = 2,
              curve = shape.curveNatural,
              numberOfTicks,
              yMin,
              yMax,
              xMin,
              xMax,
              showLabels = false,
              labelWidth = 30,
              showGrid = true,
              zIndex = (100 - i),
              contentInset = {
                top: 20,
                bottom: 20
              }
            } = chart
            const Labels = ({ x, y, data }) => (
              data.map((value, index) => (
                <G
                  key={index}
                  x={index === 0 ? x(index) + labelWidth / 2 : index === data.length - 1 ? x(index) - labelWidth / 2 : x(index)}
                  y={y(value) - 26 < contentInset.top ? contentInset.top + y(value) : y(value) - 20}
                  width={labelWidth}
                  height={26}
                >
                  <Rect
                    width={labelWidth}
                    height={26}
                    stroke='#b1b1b1'
                    strokeWidth={1}
                    fill='white'
                    x={-labelWidth / 2}
                    y={-14}
                    ry={13}
                    rx={13}
                  />
                  <Text
                    x={0}
                    fontFamily={Platform.select({ web: 'ubuntu-bold' })} // TODO fontFamily fix
                    fontSize={14}
                    fontWeight='bold'
                    alignmentBaseline='middle'
                    textAnchor='middle'
                    fill='#888888'
                  >
                    {labelFormatter(value)}
                  </Text>
                </G>
              ))
            )
            const Decorator = ({ x, y, data }) => {
              return data.map((value, index) => (
                <Circle
                  key={`${i}-${index}`}
                  cx={x(index)}
                  cy={y(value)}
                  r={strokeWidth * 1.1}
                  stroke={stroke}
                  strokeWidth={strokeWidth}
                  fill={stroke}
                />
              ))
            }
            return (
              <Chart
                key={i}
                data={data}
                svg={{ stroke, strokeWidth }}
                curve={curve}
                numberOfTicks={numberOfTicks}
                contentInset={contentInset}
                yMin={yMin}
                yMax={yMax}
                xMin={xMin}
                xMax={xMax}
                showGrid={showGrid}
                zIndex={zIndex}
              >
                {showLabels &&
                  <Labels />}
                <Decorator />
                {i === series.length - 1 && yAxis &&
                  <YAxis />}
              </Chart>
            )
          })}
        </Container>
      </Container>
    )
  }
}
